const About = () => import('@/pages/About.vue')
const TermsOfUse = () => import('@/pages/TermsOfUse.vue')
const PrivacyPolicy = () => import('@/pages/PrivacyPolicy.vue')
export default [
    {
        path: '/a-propos',
        component: About,
        name: 'about',
        meta: {
            title: "À propos",
            guard: '',
        },
    },
    {
        path: '/politique-de-confidentialite',
        component: PrivacyPolicy,
        name: 'privacy',
        meta: {
            title: "Politique de confidentialité",
            guard: '',
        },
    },
    {
        path: '/conditions-d-utilisation',
        component: TermsOfUse,
        name: 'terms',
        meta: {
            title: "Conditions d'utilisation",
            guard: '',
        },
    },
]
